import { render, staticRenderFns } from "./ConversationItemMedia.vue?vue&type=template&id=905e1fd4"
import script from "./ConversationItemMedia.vue?vue&type=script&lang=js"
export * from "./ConversationItemMedia.vue?vue&type=script&lang=js"
import style0 from "./ConversationItemMedia.vue?vue&type=style&index=0&id=905e1fd4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports